// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2rJ5K","row":"styles_row__2auHC"};